module.exports = __webpack_public_path__ + "static/media/cyprus.edd66b54.jpg";